import React from 'react'

import pdf from '../assets/pdf-document.svg';
import word from '../assets/word-document.svg';

const ModuleDocument = ({ name, type, link }) => {
    let image;

    if (type === 'pdf') {
        image = pdf;
    } else if (type === 'word') {
        image = word;
    } else {
        image = null;
    }

    return (
        <a className="block m" href={link} target="_blank" rel="noopener noreferrer">
            <div className="flex items-center mb-6">
                {image && <img src={image} height={35} className="mr-6" alt={`${type} document`} />}
                <span className="text-brandMidBlue underline">{name}</span>
            </div>
        </a>
    );
};

export default ModuleDocument;